module.exports = __webpack_public_path__ + "static/hcsunscreen-590e5db5e028262bd1e8b3076903a067.jpg";